module.exports = __webpack_public_path__ + "6bc2c17/img/skip.74080b67.svg";